import "./Search.module.css";
import Header from "@/reusable_sections/Header";
import CatalogSearch from "./sections/CatalogSearch";
import Footer from "@/reusable_sections/Footer";
export default function SearchPage() {
  return <div>
      <Header />
      <CatalogSearch />
      <Footer />
    </div>;
}